export default __webpack_public_path__ + "static/media/no-image.254fc792.png";